module.exports = __webpack_public_path__ + "static/solution10-c8d0183a4ebcaf75120c639b9143fd0d.png";